import { TargetStorage } from "../types/targetStorageTypes";
import axios from "@/utils/axios";

export const getStorages = async (): Promise<TargetStorage[]> => {
    const response = await axios.get('/target_storage/getStorages');
    return response.data;
};

export const createStorage = async (storage: TargetStorage): Promise<TargetStorage> => {
    const response = await axios.post('/target_storage/createStorage', storage);
    return response.data;
};

export const updateStorage = async (id: string, updatedData: TargetStorage): Promise<TargetStorage> => {
    const response = await axios.put(`/target_storage/updateStorage/${id}`, updatedData);
    return response.data;
};

export const deleteStorage = async (id: string): Promise<boolean> => {
    const response = await axios.delete(`/target_storage/deleteStorage/${id}`);
    return response.data;
};

export const publishToTargetStorage = async (materializationId: string, storageTargetId: string) => {
    const response = await axios.post(
        `/target_storage/publish/${materializationId}`,
        { storage_target_id: storageTargetId }
    );
    return response.data;
};